export default "__VITE_ASSET__9d8b75dd__"